var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.errorMessage)?_c('div',{staticClass:"error-message",on:{"click":_vm.hideErrorMessage}},[_c('UIIcon',{attrs:{"type":"alert"}}),_c('span',{attrs:{"id":"global-error-message-text"},domProps:{"innerHTML":_vm._s(_vm.message)}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }